import { AccountAddress } from "@aptos-labs/ts-sdk";

import type { TargetedAnnouncement } from "./types";

const memo = <T>(loader: () => Promise<T>) => {
  let cached: Promise<T> | null = null;
  return () => {
    // Drop the cache on failure so a transient chunk-load error can be retried
    // on the next call instead of poisoning the memo for the whole session.
    cached ??= loader().catch((error: unknown) => {
      cached = null;
      throw error;
    });
    return cached;
  };
};

const loadBonusReferralCodes20260428 = memo(async () => {
  const { default: addresses } = await import("./recipients/bonus-referral-codes-2026-04-28.json");
  return new Set(addresses.map((a) => AccountAddress.fromString(a).toString()));
});

export const TARGETED_ANNOUNCEMENTS: readonly TargetedAnnouncement[] = [
  {
    id: "bonus-referral-codes-2026-04-28",
    loadRecipients: loadBonusReferralCodes20260428,
    i18nKey: "bonusReferralCodes20260428",
    link: { href: "/points" },
  },
];
